import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=c07efc0a&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=c07efc0a&prod&lang=scss&scoped=true"
import style1 from "./Faqs.vue?vue&type=style&index=1&id=c07efc0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07efc0a",
  null
  
)

export default component.exports